import type { FilterConfig } from '#types/config/components/filter'

export default {
  applyButtonVariant: 'secondary'
} satisfies FilterConfig['option']['priceInput']
